


import { RequestMaterial } from '../../../models/requestMaterial';
import { RequestDetail } from '../../../models/requestDetail';
import { Attachments } from '../../../models/attachments';
import '../templates/material.scss';
import { IRequestDetailService } from '../../../services/requestDetailService';
import {INotificationService } from '../../../../../../core/notificationService';


export class MaterialController implements ng.IController {

    static $inject = ['$mdMedia', 'requestDetailService', '$scope', 'NotificationService'];

    constructor(private _$mdMedia: angular.material.IMedia, private requestDetailService: IRequestDetailService,
        private _$scope: angular.IScope, private _notificationService: INotificationService) {
    }

    requestMaterial: RequestMaterial;
    requestDetail: RequestDetail;

    $onInit() { }

    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    isAttachmentExists(rM : RequestMaterial ): boolean {
        return (rM !== undefined && rM.requestAttachments !== undefined && rM.requestAttachments.length > 0);
    }


    downloadAttachmentById(attachmentId, attachmentName) {

        this.requestDetailService.downloadAttachmentByAttachmentId(attachmentId)
            .then(r => {

                var byteArray = new Uint8Array(r);

                var blob = new Blob([byteArray], { type: this.getContentType(attachmentName) });

                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = attachmentName;
                link.click();

            })
            .catch((r) => {
                this._notificationService.showToast("Unable to Download Attachment, Technical Error Has Occured!");
            });

    }

    getContentType(fileName: string): string {
        if (fileName !== null) {
            var fileExtension = "";
            if (fileName.lastIndexOf(".") > 0) {
                fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);
                {

                    if (fileExtension.toLowerCase().toString().trim() === 'doc')
                        return 'application/msword';
                    else if (fileExtension.toLowerCase().toString().trim() === 'docx')
                        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                    else if (fileExtension.toLowerCase().toString().trim() === 'xls')
                        return 'application/vnd.ms-excel';
                    else if (fileExtension.toLowerCase().toString().trim() === 'xlsx')
                        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    else if (fileExtension.toLowerCase().toString().trim() === 'gif')
                        return 'image/gif';
                    else if (fileExtension.toLowerCase().toString().trim() === 'jpg')
                        return 'image/jpeg';
                    else if (fileExtension.toLowerCase().toString().trim() === 'pdf')
                        return 'application/pdf';
                    return 'application/octet-stream';


                }
            }

        }
        return 'application/octet-stream';
    }

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/directives/materials/controllers/materialController.ts
 **/